import { FaUserCircle, FaSignOutAlt } from "react-icons/fa";

export default function AdminNavbar() {
  return (
    <nav className="navbar navbar-light bg-white border-bottom px-4">
      <span className="navbar-brand fw-semibold">
        Dashboard Overview
      </span>

      <div className="d-flex align-items-center gap-3">
        <FaUserCircle size={22} />
        <button className="btn btn-outline-danger btn-sm">
          <FaSignOutAlt className="me-1" />
          Logout
        </button>
      </div>
    </nav>
  );
}
